// Module
var code = "<template> <require from=\"./sign-up.scss\"></require> <router-view></router-view> </template> ";
// Exports
module.exports = code;